module.exports = __webpack_public_path__ + "img/2.9dd38b0d.png";